import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  private KEY = 'ng_biilog_cliente';
  private KEYID = 'cliente_id';
  private KEYP = 'ng_biilog_cliente_permissions';

  public getToken() {
    return localStorage.getItem(this.KEY);
  }

  public saveToken(token: string, account: any) {
    localStorage.setItem(this.KEY, token);
    localStorage.setItem(this.KEYID, account.clientId.toString());
    localStorage.setItem(this.KEYP, JSON.stringify(account.permissions));
  }

  public deleteToken() {
    localStorage.removeItem(this.KEY);
  }
}
